import React, { useState, useEffect } from "react";
import Table from "./Table";
import style from "./report.module.scss";
import ProfileService from "../../../service/profile";
import Filter from "./Filter";
import moment from "moment";
import { PageTitle } from "../../components/common";
export default function CommissionReport() {
  const profileService = new ProfileService();
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [response, setResponse] = useState({
    tableData: [],
    totalCount: 0,
  });
  const [date, setDate] = useState({
    start: moment().startOf("month"),
    end: moment(),
    label:
      moment().startOf("month").format("MMMM D, YYYY") +
      " - " +
      moment().format("MMMM D, YYYY"),
  });
  const [loader, setLoader] = useState(false);
  const [type, setType] = useState("");
  useEffect(() => {
    setLoader(true);
    profileService
      .commissionReport({
        pagination,
        type,
        start: moment(date.start).format("YYYY-MM-DD"),
        end: moment(date.end).format("YYYY-MM-DD"),
      })
      .then((res) => {
        setLoader(false);
        setResponse((prev) => ({
          ...prev,
          tableData: res.data.table_data,
          totalCount: res.data.count,
        }));
      })
      .catch((err) => {
        setLoader(false);
      });
  }, [pagination.pageIndex, pagination.pageSize, date]);

  const columnsArr = [
    {
      accessorKey: "category",
      header: "Category",
      size: 150,
    },
    {
      accessorKey: "total_amount",
      header: "Total Amount",
      size: 150,
    },
    {
      accessorKey: "tax",
      header: "Tax",
      size: 150,
    },
    {
      accessorKey: "lay-way",
      header: "Lay Way",
      size: 150,
    },
    {
      accessorKey: "amount_payable",
      header: "Amount Payable",
      size: 150,
    },
    {
      accessorKey: "transaction_date",
      header: "Transaction Date",
      size: 150,
    },
  ];
  return (
    <>
      <div style={{ paddingBottom: "20px" }}>
        <PageTitle title="unilevel_commission_report" buttonOn={false} />
      </div>
      <div className={style.filterOutline}>
        <Filter
          loader={loader}
          filter={response.filter}
          setType={setType}
          date={date}
          setDate={setDate}
        />
      </div>
      <div className={style.outline}>
        {response.tableData && (
          <Table
            pagination={pagination}
            setPagination={setPagination}
            totalCount={response.totalCount}
            columnsArr={columnsArr}
            data={response.tableData}
          />
        )}
      </div>
    </>
  );
}
